import type { ComponentProps, ReactNode } from "react";
import type { CarouselSize } from "src/types/shared/common";
import { CarouselId } from "src/website-apps/shared/components/carousel-module/carousel-analytics-event";
import { RecommendedForYou } from "src/website-apps/shared/components/recommended-for-you/RecommendedForYou";

interface RecommendedForYouOnHome {
  readonly items: ComponentProps<typeof RecommendedForYou>["items"];
  readonly selectedCarouselGenre: number;
  readonly carouselSize: CarouselSize | undefined;
  readonly title?: ReactNode;
}

/**
 * Displays a "Recommend for you" carousel in home.
 * TMHomeRecommendedForYouDateRange (24763) deployed variant — date ranges always enabled.
 */
export const RecommendedForYouOnHome = ({
  items,
  selectedCarouselGenre,
  carouselSize,
  title,
}: RecommendedForYouOnHome) => (
  <RecommendedForYou
    carouselKey="RecommendedForYou"
    refreshOnFirstRender
    selectedCarouselGenre={selectedCarouselGenre}
    items={items}
    size={carouselSize}
    showDateRanges
    title={title}
    analyticsCarouselId={CarouselId.RecommendedForYou}
  />
);
